import { useGetPayments } from "@/hooks/payments";

export function useGetDeposits(reservationId: string) {
  const q = useGetPayments(reservationId);
  return { ...q, data: q.data?.filter((p) => p.isDeposit) };
}
